import PageLayout from "@/pages/home/components/PageLayout";
import BlogSNSSection from "@/pages/home/components/BlogSNSSection";

export default function BlogPage() {
  return (
    <PageLayout>
      <BlogSNSSection />
    </PageLayout>
  );
}
